/**
 * Route path patterns (React Router `:param` syntax) for pages where a
 * version-mismatch page reload is safe — i.e. the user is not mid-flow and
 * a reload will not lose unsaved work.
 *
 * Keep in sync with the route definitions in createRouter.tsx. Use React
 * Router-style parameter syntax (`:paramName`) rather than regex literals so
 * the paths are readable and can be converted to `RegExp` via
 * `routePathToRegex` from `@thalamos/common`.
 */
export const RELOAD_SAFE_ROUTE_PATHS = [
  "/",
  "/incident/archive",
  "/incident/:id/progress",
] as const;
